import { ICON_SIZE } from '@components/v2/constants';
import { SxProps, Theme, alpha, darken } from '@mui/material';

const GRID_BUTTON_MIN_WIDTH = 60;
const GRID_BUTTON_MAX_WIDTH = 82;
const SELECTED_BACKGROUND_OPACITY = 0.08;
const SELECTED_BACKGROUND_HOVER_OPACITY = 0.16;

interface GridButtonSxParams {
  hasSelectedPacks: boolean;
}

export const getGridButtonSx = ({ hasSelectedPacks }: GridButtonSxParams): SxProps<Theme> => {
  return (theme) => {
    const selectedBackground = alpha(theme.palette.accent.main, SELECTED_BACKGROUND_OPACITY);

    return {
      minWidth: GRID_BUTTON_MIN_WIDTH,
      maxWidth: GRID_BUTTON_MAX_WIDTH,
      borderRadius: `${theme.shape.borderRadiusMd}px`,
      padding: theme.spacing(0.75, 0.25, 0.75, 0.75),
      ...theme.typography.body2,
      color: hasSelectedPacks ? theme.palette.accent.main : theme.palette.text.secondary,
      ...(hasSelectedPacks && {
        backgroundColor: selectedBackground,
        '&:hover': {
          backgroundColor: alpha(theme.palette.accent.main, SELECTED_BACKGROUND_HOVER_OPACITY),
        },
        '&:active': { backgroundColor: darken(selectedBackground, 0.1) },
      }),
      '& .MuiButton-endIcon': {
        marginLeft: 0,
        marginRight: 0,
        '& > *:first-of-type': {
          width: ICON_SIZE.sm,
          height: ICON_SIZE.sm,
        },
      },
    };
  };
};
